export default __webpack_public_path__ + "static/media/tianke.80d1be4f.png";